import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { Link } from "react-router-dom";
import BASE_URL from "api/Api";
import { FaLayerGroup, FaEdit, FaCalendarAlt, FaImages } from "react-icons/fa";
import "assets/theme/admin_list.css";

const SectionHeroList = () => {
  const [heroes, setHeroes] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHeroes = async () => {
    try {
      const res = await apiFetch("leader_admin/get_hero_section_by_type");
      setHeroes(res.data || []);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHeroes();
  }, []);

  const getTypeLabel = (type) => {
    switch (type) {
      case "about":
        return "अबाउट विभाग (About Us)";
      case "schemes":
        return "योजना विभाग (Schemes)";
      case "gallery":
        return "गॅलरी विभाग (Gallery)";
      default:
        return type;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-3">
        {/* Header Card */}
        <div className="admin-header-card mb-4">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 position-relative" style={{ zIndex: 1 }}>
            <div className="d-flex align-items-center gap-3">
              <div className="admin-header-icon-box">
                <FaLayerGroup />
              </div>
              <div>
                <h4 className="text-white fw-bold mb-1" style={{ fontSize: "1.3rem" }}>
                  विभागनिहाय हीरो व्यवस्थापन / Section Hero Banners
                </h4>
                <p className="text-white-50 mb-0" style={{ fontSize: "0.88rem" }}>
                  अबाउट | योजना | गॅलरी विभाग बॅनर व्यवस्थापन
                </p>
              </div>
            </div>

            <Link to="/update_section_hero" className="btn btn-admin-add">
              <FaEdit /> <span>संपादन करा (Update Hero)</span>
            </Link>
          </div>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          <div className="card-body p-0">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-warning" role="status"></div>
                <p className="text-muted mt-2 fw-semibold mb-0">माहिती लोड होत आहे...</p>
              </div>
            ) : heroes.length === 0 ? (
              <div className="text-center py-5">
                <FaImages className="text-muted mb-3" style={{ fontSize: "2.5rem", opacity: 0.4 }} />
                <h6 className="text-muted fw-bold">कोणताही हीरो विभाग उपलब्ध नाही</h6>
                <p className="text-muted small mb-0">No section hero headers have been configured yet.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-admin-custom align-middle">
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }}>Sr. No.</th>
                      <th>विभाग (Section)</th>
                      <th style={{ width: "120px" }}>प्रतिमा (Banner)</th>
                      <th>शीर्षक (Title)</th>
                      <th>शेवटचा अपडेट (Updated)</th>
                      <th className="text-center" style={{ width: "120px" }}>क्रिया (Action)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {heroes.map((hero, index) => (
                      <tr key={hero.hero_id}>
                        <td>
                          <span className="fw-semibold text-muted">{(index + 1).toString().padStart(2, "0")}</span>
                        </td>

                        <td>
                          <span className="badge bg-primary bg-opacity-10 text-primary fw-bold px-3 py-1.5 rounded-pill">
                            {getTypeLabel(hero.type)}
                          </span>
                        </td>

                        <td>
                          {hero.image_url ? (
                            <img
                              src={`${BASE_URL}/${hero.image_url}`}
                              alt="Hero"
                              className="rounded-3 shadow-sm border"
                              style={{
                                width: "90px",
                                height: "55px",
                                objectFit: "cover",
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.style.display = "none";
                              }}
                            />
                          ) : (
                            <span className="badge bg-secondary bg-opacity-10 text-secondary fw-normal">प्रतिमा नाही</span>
                          )}
                        </td>

                        <td className="fw-bold text-dark">{hero.title}</td>

                        <td>
                          <small className="text-muted">
                            <FaCalendarAlt className="me-1" />
                            {new Date(hero.updated_at).toLocaleDateString("mr-IN")}
                          </small>
                        </td>

                        <td>
                          <div className="d-flex justify-content-center gap-2">
                            <Link
                              to={`/update_section_hero/${hero.hero_id}`}
                              className="btn-action-icon edit"
                              title="संपादन करा"
                            >
                              <FaEdit />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default SectionHeroList;